export default {"src":"/_next/static/media/learn_lead_excel.00d63f47.svg","height":31,"width":31,"blurWidth":0,"blurHeight":0};